<template>
  <ClientOnly>
    <DmModal
      v-model="modals.calendarRequest"
      title="Poproś o udostępnienie wolnych terminów"
      class="garage-calendar-request-modal"
    >
      <div class="garage-calendar-request-modal__wrapper">
        <p class="garage-calendar-request-modal__paragraph">
          Warsztat otrzyma twoją prośbę o udostępnienie wolnych terminów na stronie. Gdy udostępni kalendarz,
          powiadomimy
          Cię o tym na podany adres email.
        </p>

        <form
          v-if="!isFormSent"
          id="calendar-request-modal.form"
          @submit.prevent="submit"
        >
          <DmInput
            id="calendar-request-modal.email"
            v-model="form.fields.email"
            placeholder="np. jankowalski@dobrymechanik.com"
            name="email"
            pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
            :required="true"
            error="Wpisz poprawny e-mail"
            label="E-mail"
            type="email"
            @update:errors="updateErrors($event, 'email')"
          />
          <DmCheckbox
            class="mt-3 mb-5"
            :required="true"
            id="calendar-request-modal.agreement"
            v-model="form.fields.agreement"
            label='Akceptuję <a href="/pomoc/regulamin/" target="__blank">regulamin</a> DobryMechanik.pl oraz <a href="/pomoc/polityka_prywatnosci/" target="__blank">politykę prywatności</a>'
            @update:errors="updateErrors($event, 'agreement')"
          />

          <DmButton
            title="Wyślij wiadomość"
            class="w-100"
          />
        </form>

        <div
          class="garage-calendar-request-modal__already-sent"
          v-else
        >
          <NuxtImg
            width="24px"
            height="24px"
            alt="Twoja prośba została wysłana"
            src="/_nuxt/greenCheckmark.svg"
          />
          Twoja prośba została wysłana. Na ten moment rekomendujemy sprawdzenie innych warsztatów w okolicy. Damy Ci
          znać,
          jeśli warsztat umożliwi rezerwację wizyt online.
        </div>
        <GarageSuggestedGarages
          v-if="!garage?.premium"
          :itemsToShow="1.2"
          :garage="garage"
          :suggestedGarages="suggestedGarages"
        />
      </div>
    </DmModal>
  </ClientOnly>
</template>

<script setup lang="ts">
import { DmCheckbox, DmModal, DmButton, DmInput } from '@dobrymechanik/vue-ui-v2';
import { appRequests } from '~/api/app-instance';
import type { GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead, RankingJsonldSuggestedGarageReadRankingRead } from '~/api/docs/api';
const GarageSuggestedGarages = defineAsyncComponent(() => import('@/components/GarageSuggestedGarages.vue'));

interface IProps {
  modals: any;
  garage?: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  suggestedGarages?: RankingJsonldSuggestedGarageReadRankingRead[];
}

interface IGarageCalendarRequestModalFormFields {
  email: string;
  agreement: boolean;
}

// use
const route = useRoute();
const { form, valid, updateErrors, checkFormValidity } = useFormCreator<IGarageCalendarRequestModalFormFields>({
  email: '',
  agreement: false
});
const isFormSent: Ref<boolean> = ref(false);
const notification = useNotification();

// props
const props = defineProps<IProps>();

// methods 
const submit = async (e: any) => {
  const isFormValid = await checkFormValidity(e.target.id);

  if (isFormValid) {

    try {
      await appRequests.postAppGarageCreateDriverReminder({
        garageId: props.garage?.id,
        email: form.value.fields.email,
        topic: "request-online-calendar-reminder"
      });

      isFormSent.value = true;

    } catch (e: any) {
      if (e.response.status === 400) {
        notification.show({
          status: INotificationStatus.Warning,
          description: `Email jest już dodany do listy powiadomień`
        });
      }

    }
  };
};


</script>

<style lang="scss">
@import url('assets/styles/components/garage-calendar-request-modal.scss');
</style>